import { TicketFiles } from '../domain/ticket.models';

export function buildTicketFormData(
  data: Readonly<Record<string, unknown>>,
  files: Readonly<TicketFiles>,
): FormData {
  const formData = new FormData();
  formData.append('data', JSON.stringify(data));
  files.attachments?.forEach((file) => formData.append('attachments', file));
  if (files.audio) formData.append('audio', files.audio);
  if (files.video) formData.append('video', files.video);
  return formData;
}

export function resolveTicketMediaUrl(path: string, cdnUrl: string): string {
  if (!path) return '';
  const normalizedPath = path.trim().replace(/\\/g, '/');
  if (/^https?:\/\//i.test(normalizedPath)) return normalizedPath;

  try {
    return new URL(
      normalizedPath.replace(/^\/+/, ''),
      `${cdnUrl.replace(/\/+$/, '')}/`,
    ).toString();
  } catch {
    return normalizedPath;
  }
}
